module.exports = __webpack_public_path__ + "static/media/section-banner-10.cac47e81.svg";